import { Grid } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";

import { Mandatory } from "../FormOne";
import { Autocomplete } from "../../../../components";
import AutocompleteMultiSelect from "../../../../components/MultiselectAutoComplete";

function DropDown({
  counts,
  state,
  handleCheckChange,
  field,
  editState,
  dispatch,
}) {
  const [input, setInput] = useState({});

  useEffect(() => {
    if (state[field.name]) {
      setInput((prev) => ({
        ...prev,
        [field.name]: state[field.name],
      }));
    }
  }, [state, field.name]);

  return (
    <Fragment>
      {field.control_id === 2 && field.multi_select && (
        <Fragment>
          <Grid item xs={6}>
            <Grid container spacing={3}>
              <Grid item xs={12} style={{ paddingTop: "0px" }}>
                <Mandatory
                  dispatch={dispatch}
                  state={state}
                  editState={editState}
                  field={field}
                  handleCheckChange={handleCheckChange}
                />
              </Grid>

              <Grid item xs={12} style={{ paddingTop: "0px" }}>
                <AutocompleteMultiSelect
                  size="small"
                  forcePopupIcon={!editState ? false : true}
                  name={`${field.name}.value`}
                  state={state}
                  value={input[field.name]?.value}
                  disabled={
                    !editState || (!field.is_ioh_contributor && counts < 2)
                  }
                  defaults={{
                    primaryKey: "value",
                    displayLabel: "label",
                  }}
                  options={field.options}
                  placeholder={
                    (input[field.name]?.value?.length === 0 ||
                      input[field.name]?.value?.length === undefined) &&
                    field.placeholder
                  }
                  onChange={(_, arr, reason, detail) =>
                    handleChange(
                      arr,
                      detail,
                      reason,
                      `${field.name}.value`,
                      "value",
                      field.options
                    )
                  }
                  onBlur={() => {
                    handleDropDown(
                      input[field.name]?.value,
                      field.name,
                      "value"
                    );
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Fragment>
      )}

      {field.control_id === 2 && !field.multi_select && (
        <Grid item xs={6}>
          <Grid container spacing={3}>
            <Grid item xs={12} style={{ paddingTop: "0px" }}>
              <Mandatory
                field={field}
                dispatch={dispatch}
                state={state}
                editState={editState}
                handleCheckChange={handleCheckChange}
              />
            </Grid>

            <Grid item xs={12} style={{ paddingTop: "0px" }}>
              <Autocomplete
                size="small"
                forcePopupIcon={!editState ? false : true}
                name={`${field.name}.value`}
                placeholder={field.placeholder}
                value={input[field.name]?.value}
                defaults={{
                  primaryKey: "value",
                  displayLabel: "label",
                }}
                sx={{
                  "& .MuiSvgIcon-root": {
                    display: !editState && "none",
                  },
                }}
                options={field.options}
                disabled={
                  !editState || (!field.is_ioh_contributor && counts < 2)
                }
                onChange={(_, value, type) =>
                  handleChangeSingleSelect(value, type, `${field.name}`)
                }
                onBlur={() => {
                  handleDropDown(input[field.name]?.value, field.name, "value");
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
    </Fragment>
  );

  function handleDropDown(value, name, key) {
    dispatch({
      type: "MULTI_DROP_DOWN",
      payload: { value, name, key },
    });

    if (field.is_ioh_contributor && value.length > 0) {
      let value = true;
      let key = "mandatory";
      dispatch({
        type: "CALCULATE_PERCENTAGE",
        payload: { value, name, key },
      });
    }

    if (field.is_ioh_contributor && value.length === 0) {
      let value = false;
      let key = "mandatory";
      dispatch({
        type: "CALCULATE_PERCENTAGE",
        payload: { value, name, key },
      });
    }
  }

  function handleChangeSingleSelect(value, type, name) {
    function setValue(val) {
      return value.value;
    }

    if (type === "selectOption") {
      setInput((prev) => ({
        ...prev,
        [name]: { value: setValue(input[name]) },
      }));
    } else {
      value = {
        value: "",
        label: "",
      };

      setInput({ [name]: { value: setValue(input[name]) } });
    }
  }

  function handleChange(arr, { option }, reason, name, displayName, options) {
    let objectName = name.substring(0, name.indexOf("."));

    setInput((prev) => ({
      ...prev,
      [objectName]: setValuesOfDropDown(input[objectName]?.value),
    }));

    function setValuesOfDropDown(val = []) {
      let values = [...val];

      if (reason === "removeOption") {
        if (option.value) {
          values = [...values.filter((items) => items !== option?.value)];
        } else {
          values?.pop();
          option = options.filter((item) => item?.label === option)[0];
        }
      }

      if (reason === "selectOption") {
        values.push(option[displayName]);
      }

      val = {
        value: values,
      };

      return val;
    }
  }
}

export default DropDown;
